import React, {useMemo} from 'react';
import {useTypedSelector} from '../../Hooks/useTypedSelector';
import {translate} from '../../Services/translation';

interface ProductTabsProps {
    id?: string;
    gtin?: string;
    gtins?: { key: string; value: string };
    visualArticleNumber?: string;
    visualArticleNumbers?: { key: string; value: string };
    isBusinessCustomer?: boolean;
    initialSelectVariantId?: string;
}


const ProductPageVariantIdentifier = ({
                                          gtin,
                                          gtins,
                                          isBusinessCustomer,
                                          visualArticleNumber,
                                          visualArticleNumbers,
                                          initialSelectVariantId
                                      }: ProductTabsProps) => {
    const {articleNumber} = useTypedSelector((state) => state.buyButton);

    var variantArticleNumber = useMemo(() => {
        if (articleNumber && articleNumber.length > 0 && visualArticleNumbers) {
            return visualArticleNumbers[articleNumber];
        } else if (initialSelectVariantId && initialSelectVariantId != '' && visualArticleNumbers) {
            return visualArticleNumbers[initialSelectVariantId]
        } else {
            return visualArticleNumber
        }
    }, [articleNumber])

    var variantGtin = useMemo(() => {
        if (articleNumber && articleNumber.length > 0 && gtins) {
            return gtins[articleNumber];
        } else if (initialSelectVariantId && initialSelectVariantId != '' && gtins) {
            return gtins[initialSelectVariantId];
        } else {
            return gtin;
        }
    }, [articleNumber])

    return (
        <>
            <div className="product-page__id">
                {translate('product.articlenumber')}
                {variantArticleNumber
                    ? variantArticleNumber
                    : translate('product-page.please-select-variant')}

                <div className={`${isBusinessCustomer ? '' : 'hidden'}`}>
                    <span className="product-page__id-divider">|</span> {translate('product.gtin')} {variantGtin}
                </div>
            </div>
        </>
    );
};

export default ProductPageVariantIdentifier;
